module.exports = __webpack_public_path__ + "static/scale-model-of-wright-park-in-tacoma-washington-90135d40102673b9ab2c4dcfe3ae2d4a.png";